import React from "react";
import { useSelector } from "react-redux";
import DifferentialAssessment from "../../service-steps/differential/differential-assessment";

const Differential = () => {
  const { clinicalServiceObj } = useSelector((state) => state.clinicalService);
  const { currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;

  const renderStep = () => {
    const subStep = currentSubStep === 0 ? 1 : currentSubStep;
    switch (subStep) {
      case 1:
        return <DifferentialAssessment />;
    }
  };
  return renderStep();
};

export default Differential;
